import React from 'react'

const ItemsTable = () => {
    return (
        <div>ItemsTable</div>
    )
}

export default ItemsTable